// Transforms time string like 01:30:00 to hours in number.

const transformTimeStringToNumber = (value: string): number => {
    const [hours, minutes, seconds] = value.split(':')

    return parseInt(hours, 10) + (parseInt(minutes, 10) / 60) + (parseInt(seconds || '0', 10) / 3600)
}

export default transformTimeStringToNumber
